import { render } from "./AppTableTextHeader.vue?vue&type=template&id=106746f2&scoped=true"
import script from "./AppTableTextHeader.vue?vue&type=script&lang=js"
export * from "./AppTableTextHeader.vue?vue&type=script&lang=js"

import "./AppTableTextHeader.vue?vue&type=style&index=0&id=106746f2&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-106746f2"]])

export default __exports__